<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            EBC turbo
                        </a>
                        <a href="/jinrong/ea/" class="ebc-tab-line-item"> 其他EA插件 </a>
                    </div>
                </div>
                <section class="section1">
                    <h1 class="">EBC Turbo 账户分析系统</h1>
                    <div class="forex-title-intro">
                        精准评估账户表现，洞察交易行为逻辑 —— 借助EBC Turbo多维分析工具，系统掌握盈亏走势与行为模型，让策略进阶更可视、更理性。
                    </div>
                    <div class="forex-btn-group">
                        <ebc-btn class="ebc-btn">立即获取</ebc-btn>
                    </div>
                    <!-- <img
                class="ea-turbo-banner"
                src="/ebc-static/image/forex/tools/ea_turbo_bg.png"
                alt=""
              /> -->
                </section>

                <section class="section2">
                    <h2 class="">使用教程</h2>
                    <div class="swiper document-list-wrapper1">
                        <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                                <swiper-slide v-for="vo in basicList" :id="vo.id">
                                    <div class="document-item">
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                            <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                        </a>
                                        <div>
                                            <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                                vo.post_title }}</a>
                                            <div class="document-btn-text">
                                                {{ formateTime(vo.published_time) }}
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                    </div>
                </section>



            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getEaTurboTutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    components: {
        forexMenu,
        Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getEaTurboTutorial().then(response => {
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    },
    mounted() {
        

    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>